import { Axios } from 'utils/AxiosConfig'

export const getEvents = async (payload) => {
  const { data: response } = await Axios.get(`public/event`, payload)
  return response
}
export const getEventDetail = async (payload) => {
  const { data: response } = await Axios.get(`public/event/${payload}`)
  return response
}

export const postRegisterEventPremium = async (payload, id) => {
  const { data: response } = await Axios.post(`public/event/register-directly/${id}`, payload)
  return response
}

export const postCalculateEvent = async (payload) => {
  const { data: response } = await Axios.post(`member/paid-service/calculate`, payload)
  return response
}

export const postPaidEvent = async (payload) => {
  const { data: response } = await Axios.post(`member/paid-service`, payload)
  return response
}

export const getPaidEvents = async (payload) => {
  const { data: response } = await Axios.get(`member/event`, payload)
  return response
}

export const getRegisteredPaidEvents = async (id) => {
  const { data: response } = await Axios.get(`member/event/${id}`)
  return response
}